<template>
  <div id="notifelement">
    <div class="register-notif">
      <div class="row">
        <div class="col-md-8 col-lg-offset-2">
          <div class="new-message-box">
            <div class="new-message-box-success">
              <div class="info-tab tip-icon-success"><i></i></div>
              <div class="tip-box-success">
                <h3 class="text-dark">Yth, {{ data.name }}</h3>
                <p class="font-16">
                  Terima kasih telah melakukan registrasi.
                  <br />
                  Jika ada pertanyaan atau ingin informasi lebih lanjut dapat
                  menghubungi panitia.
                </p>
                <h5>Panitia Rakernas IV Peradi</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataprop"],
  data() {
    return {
      url: "",
      data: {
        name: null,
      }
    };
  },
  created() {
    this.initial();
  },
  methods: {
    initial() {
        if(!_.isEmpty(this.dataprop)) {
            this.data = this.dataprop
        }
    },
  },
  mounted: function () {
    var target = document.querySelector("#notifelement");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top,
      },
      500
    );
  },
};
</script>
<style>
#notifelement {
    min-height: 50vh;
}
</style>
